var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTalktalk = function SvgTalktalk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.997 1h24a1 1 0 0 1 1 1v10.996a1 1 0 0 1-1 1l-20 .004a1 1 0 0 1-1-1V3.5l-3-2.5Z",
    fill: "#E5F9EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.997 3.494A2.498 2.498 0 0 1 3.497 1h8c1.38 0 2.5 1.118 2.5 2.494v6.824a2.498 2.498 0 0 1-2.5 2.494H5.384a.728.728 0 0 0-.513.212l-1.587 1.583c-.842.84-2.286.245-2.286-.946V3.494Z",
    fill: "#E6F9EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.997 3.494A2.498 2.498 0 0 1 3.497 1h8c1.38 0 2.5 1.118 2.5 2.494v6.824a2.498 2.498 0 0 1-2.5 2.494H5.384a.728.728 0 0 0-.513.212l-1.587 1.583c-.842.84-2.286.245-2.286-.946V3.494Zm2.5-1.368a1.37 1.37 0 0 0-1.37 1.368V13.66c0 .187.226.28.358.15l1.586-1.584a1.858 1.858 0 0 1 1.312-.541h6.115a1.37 1.37 0 0 0 1.37-1.368V3.494a1.37 1.37 0 0 0-1.37-1.368H3.497ZM5.11 6.832a.832.832 0 1 0-1.664 0 .832.832 0 0 0 1.664 0Zm3.286 0a.832.832 0 1 0-1.664 0 .832.832 0 0 0 1.664 0ZM10.85 6a.832.832 0 1 1 0 1.664.832.832 0 0 1 0-1.664Zm7.4 3.783v-.836h6.128v2.85h-1.036V9.783h-5.092Zm6.204-3.933v.808H21.87v.797h3.562v.836h-8.132v-.836h3.534v-.798h-2.45V3h6.013v.826H19.42v.599h4.664v.798H19.42v.627h5.035Zm2.035 3.933v-.836h6.128v2.85h-1.036V9.783H26.49Zm6.204-3.933v.808H30.11v.797h3.562v.836H25.54v-.836h3.534v-.798h-2.45V3h6.013v.826h-4.978v.599h4.664v.798H27.66v.627h5.035Z",
    fill: "#03C75A"
  })));
};
export default SvgTalktalk;